export default "__VITE_ASSET__C3W4$bky__"